/* eslint-disable @typescript-eslint/no-explicit-any */
export const areArraysEqual = (a: any[], b: any[]): boolean => {
  if (a === b) return true;
  if (a === null || b === null) return false;
  if (a.length !== b.length) return false;

  // If you don't care about the order of the elements inside
  // the array, you should sort both arrays here.
  // Please note that calling sort on an array will modify that array.
  // you might want to clone your array first.

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

export const toggleInArray = <T>(array: T[], value: T) => {
  const index = array.indexOf(value);
  if (index > -1) {
    array.splice(index, 1);
  } else {
    array.push(value);
  }
};

export const addOrRemoveInArray = <T>(array: T[], value: T, add: boolean) => {
  const index = array.indexOf(value);
  if (index > -1 && !add) {
    array.splice(index, 1);
  } else if (index === -1 && add) {
    array.push(value);
  }
};
